// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';
import PropType from 'prop-types';

import { assetResolver } from '../../utils';
import { ButtonContainer, ButtonIcon } from './styles';

const getButtonIcon = (open, alternate) => (
  assetResolver(`${open ? 'close' : 'menu'}${alternate ? '-dark' : ''}.svg`)
);

const PrimaryNavigationButtonMenuMobile = ({
  open, onClick, visible, alternate,
}) => (
  <ButtonContainer
    aria-haspopup="menu"
    aria-expanded={open}
    aria-controls="nav-menu"
    open={open}
    visible={visible}
    onClick={onClick}
    alternate={alternate}
    data-testid="PrimaryNavigationButtonMenuMobile"
  >
    <ButtonIcon src={getButtonIcon(open, alternate)} alt="Menu" />
  </ButtonContainer>
);

PrimaryNavigationButtonMenuMobile.propTypes = {
  open: PropType.bool,
  onClick: PropType.func,
  visible: PropType.bool,
  alternate: PropType.bool,
};

PrimaryNavigationButtonMenuMobile.defaultProps = {
  open: false,
  onClick: () => undefined,
  visible: true,
  alternate: false,
};

export default PrimaryNavigationButtonMenuMobile;
